import { render, staticRenderFns } from "./RequestService.vue?vue&type=template&id=afa3978e&"
import script from "./RequestService.vue?vue&type=script&lang=js&"
export * from "./RequestService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports